class MiniCardQuickBuy extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form']
  }

  static get requiredExternalElements () {
    return ['parent', 'trigger']
  }

  connectedCallback () {
    super.connectedCallback()

    this.parentProductCard = this.closest(this.externalEls.parent.selector)
    this.touchClass = 'prd-Card-touchActive'

    this.setEventListeners()
  }

  setEventListeners () {
    this.els.form.element.addEventListener(
      'submit',
      this.handleFormSubmission.bind(this),
    )

    this.parentProductCard
      .querySelector(this.externalEls.trigger.selector)
      .addEventListener('click', this.handleMobileTriggerClick.bind(this))

    this.parentProductCard.addEventListener(
      'click',
      this.handleParentProductCardClick.bind(this),
    )
  }

  handleFormSubmission (e) {
    e.stopPropagation()

    e.preventDefault()

    window.BAO.Cart.addItemFromForm(this.els.form.element)
  }

  handleParentProductCardClick (e) {
    if (this.parentProductCard.classList.contains(this.touchClass)) {
      if (e.target.classList.contains('prd-Card_FauxLink')) {
        e.stopPropagation()
        e.preventDefault()
      }
    }
  }

  handleMobileTriggerClick (e) {
    e.stopPropagation()
    this.parentProductCard.classList.toggle(this.touchClass)
  }
}

if (!customElements.get('mini-card-quick-buy')) {
  customElements.define('mini-card-quick-buy', MiniCardQuickBuy)
}
